module.exports = __webpack_public_path__ + "assets/皇冠VIP2.e8b61b0c.svg";